import { render, staticRenderFns } from "./PageHeaderLinks.vue?vue&type=template&id=0204cb00&"
import script from "./PageHeaderLinks.vue?vue&type=script&lang=js&"
export * from "./PageHeaderLinks.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports